export default __webpack_public_path__ + "static/media/FlyingFrog32.03a57c60.png";